<template>
    <div class="mb-5 md:mb-0">
        <div class="flex flex-col md:flex-row md:items-center ">
            <div class="mt-6 border-l-4 border-black relative max-w-sm w-96">            
                <p class="mt-6 px-4 font-bold">{{ parcourName }} </p>
                <p class="px-4 "> {{ parcourDescription }}</p>
                <p class="px-4 italic">{{ parcourDate }}</p>
                <div class="absolute top-0 -ml-2.5 -mt-0.5 h-4 w-4 rounded-full bg-blue-600"></div>
                <div class="absolute bottom-0 -ml-2.5 -mt-0.5 h-4 w-4 rounded-full bg-orange-300"></div>
            </div>
            <img class="h-20 w-40  object-cover object-center rounded-lg mr-5 md:mt-0 mt-5" :src="parcourImage" alt="product" />
        </div>
    </div>
</template>

<script>
export default {
  name: 'ComponentTL',
  props: {
      parcourName: String,
      parcourDate: String,
      parcourDescription: String,
      parcourImage: String,
    }
}
</script>